/**
 * Input component
 *
 * Optional props:
 * breakOneCol : string - width of component (with unit) when it should break to one column
 * breakTwoCol : string - width of component (with unit) when it should break to two columns
 *
 * Good to know:
 * Add attribute data-th to a td to apply label when going to breakpoints given, example:
 * <Table>
 *   <thead>
 *     <tr>
 *       <th>Shown in "full width"</th>
 *     </tr>
 *   <tbody>
 *     <tr>
 *       <td data-th="Shown before value instead of <th>">Value of td</td>
 *     </tr>
 *   </tbody>
 * </Table>
 *
 * Examples of component:
 * <Table breakOneCol="400px" breakTwoCol="700px">...</Table>
 *
 */

import React from 'react';
import styled from 'styled-components';
import { colors } from '../../variables';

const Table = styled.table`
	text-align: left;
	background: #fff;
	border: 0;
	border-collapse: collapse;
	border: 1px solid ${colors.grey.normal};
	width: ${props => props.width || '100%'};
	max-width: 100%;

	thead {
		background: ${colors.grey.lightest};
		font-size: 13px;
	}

	tr {
		border-bottom: 1px solid ${colors.grey.normal};
	}

	th {
		padding: 20px 15px;
		border: 0;
		font-weight: 400;
		text-transform: uppercase;
	}

	td {
		padding: 15px 15px;
		font-size: 14px;
		line-height: 1.4;
	}

	tr:hover td {
		background: ${colors.grey.lightest};
	}

	@media screen and (max-width: ${props => props.breakTwoCol || '0px'}) {
		thead {
			display: none;
		}

		tr {
			display: flex;
			flex-wrap: wrap;
			position: relative;
		}

		td {
			display: block;
			flex: 1 0 50%;
			padding-top: 10px;
			padding-bottom: 10px;

			&:before {
				content: attr(data-th);
				display: inline-block;
				margin-right: 5px;
				font-weight: bold;
			}
		}
	}

	@media (max-width: ${props => props.breakOneCol || '0px'}) {
		thead {
			display: none;
		}

		tr {
			display: block;
		}

		td {
			display: block;
			padding-top: 10px;
			padding-bottom: 10px;

			&:before {
				content: attr(data-th);
				display: inline-block;
				margin-right: 5px;
				font-weight: bold;
			}
		}
	}
`;

class TableComponent extends React.Component {
	render() {
		const { children, ...rest } = this.props;

		return <Table {...rest}>{children}</Table>;
	}
}

export default TableComponent;



// WEBPACK FOOTER //
// ./src/components/Common/Table/Table.js